// @flow
import * as React from 'react';
import { Box, Button } from 'grommet';
import { injectIntl, type IntlShape } from 'react-intl';
import { ButtonGroup } from 'speed-js-react-web';
import type { Resource } from './types';


type Props = {
    resources: Array<Resource>,
    enabledResources: { [name: string]: Resource },
    onEnabledChange: (resource: Resource, enabled: boolean) => void,
    onFiltersChange: (resource: Resource, values: Object) => void,
    intl: IntlShape,
};


@injectIntl
class EditorResourceSelector extends React.Component<Props> {
    static defaultProps = {
        intl: {},
    };

    callbacks: {
        [string]: {
            onResourceClick: Function,
            onFiltersSubmit: Function,
        },
    } = {};

    constructor(props: Props) {
        super(props);
        props.resources.forEach((r) => {
            this.callbacks[r.name] = {
                onResourceClick: this.handleResourceClick.bind(this, r),
                onFiltersSubmit: this.handleFiltersSubmit.bind(this, r),
            };
        });
    }

    handleResourceClick(resource: Resource, e: SyntheticMouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        const { onEnabledChange, enabledResources } = this.props;
        onEnabledChange(resource, !(typeof enabledResources[resource.name] !== 'undefined'));
    }

    handleFiltersSubmit(resource: Resource, values: Object, formik: Object) {
        const { onFiltersChange } = this.props;
        onFiltersChange(resource, values);
        formik.setSubmitting(false);
    }

    render() {
        const { resources, enabledResources } = this.props;

        const { intl } = this.props;

        return (
            <Box direction="row" gap="medium" pad={{ bottom: 'small' }} align="end">
                {
                    resources.map((r) => {
                        const enabled = typeof enabledResources[r.name] !== 'undefined';

                        const labelPlural = typeof r.labelPlural === 'string'
                            ? r.labelPlural
                            : intl.formatMessage(r.labelPlural);
                        return (
                            <ButtonGroup key={`${r.name}-${r.key}`} direction="row">
                                <Button
                                    label={labelPlural}
                                    primary={enabled}
                                    onClick={this.callbacks[r.name].onResourceClick}
                                />
                            </ButtonGroup>
                        );
                    })
                }
            </Box>
        );
    }
}

export default EditorResourceSelector;
